import { makeActionCreator } from '../../../config/store/utils';
import { batch } from 'react-redux';
import { getTrucks, getCycles } from "../../../services/cyclesService";

/* ---------------- TRUCKS ---------------- */
export const GET_TRUCKS = 'GET_TRUCKS';
export const GET_TRUCKS_ERROR = 'GET_TRUCKS_ERROR';
export const GET_TRUCKS_SUCCESS = 'GET_TRUCKS_SUCCESS';

export const onGetTrucks = makeActionCreator(GET_TRUCKS);
export const onGetTrucksError = makeActionCreator(GET_TRUCKS_ERROR, 'payload');
export const onGetTrucksSuccess = makeActionCreator(GET_TRUCKS_SUCCESS, 'payload');

export const onGetTrucksThunk = () => async dispatch => {
    dispatch(onGetTrucks());
    try {
        const { data } = await getTrucks();
        const trucks = data.reduce((acc, current, index) => {
            acc.push({ ...current, id: `${index + 1}` });
            return acc;
        }, []);
        return batch(() => dispatch(onGetTrucksSuccess({ data: trucks })));
    } catch (error) {
        return batch(() => dispatch(onGetTrucksError({ error })));
    }
};

/* ------------- HELPERS COMUNES ------------- */
const normalizeCycles = (data) => {
    let ciclos =
        Array.isArray(data) ? data :
            typeof data === 'string' ? JSON.parse(data) :
                (data && typeof data.body === 'string') ? JSON.parse(data.body) :
                    (data && Array.isArray(data.body)) ? data.body : [];

    // NaN -> null
    ciclos = ciclos.map(row => {
        const out = { ...row };
        Object.keys(out).forEach(k => {
            if (Number.isNaN(out[k])) out[k] = null;
        });
        return out;
    });

    // agrega id string
    return ciclos.map((row, i) => ({ ...row, id: String(i + 1) }));
};

/* --------- CYCLES TURNO ACTUAL --------- */
export const GET_CYCLES_CURRENT = 'GET_CYCLES_CURRENT';
export const GET_CYCLES_CURRENT_ERROR = 'GET_CYCLES_CURRENT_ERROR';
export const GET_CYCLES_CURRENT_SUCCESS = 'GET_CYCLES_CURRENT_SUCCESS';

export const onGetCyclesCurrent = makeActionCreator(GET_CYCLES_CURRENT);
export const onGetCyclesCurrentError = makeActionCreator(GET_CYCLES_CURRENT_ERROR, 'payload');
export const onGetCyclesCurrentSuccess = makeActionCreator(GET_CYCLES_CURRENT_SUCCESS, 'payload');

export const onGetCurrentCyclesThunk = () => async dispatch => {
    dispatch(onGetCyclesCurrent());
    try {
        const { data } = await getCycles({}); // sin params -> turno actual
        const ciclos = normalizeCycles(data);
        return batch(() => dispatch(onGetCyclesCurrentSuccess({ data: ciclos })));
    } catch (error) {
        return batch(() => dispatch(onGetCyclesCurrentError({ error })));
    }
};

/* --------- CYCLES HISTÓRICOS --------- */
export const GET_CYCLES_HISTORY = 'GET_CYCLES_HISTORY';
export const GET_CYCLES_HISTORY_ERROR = 'GET_CYCLES_HISTORY_ERROR';
export const GET_CYCLES_HISTORY_SUCCESS = 'GET_CYCLES_HISTORY_SUCCESS';

export const onGetCyclesHistory = makeActionCreator(GET_CYCLES_HISTORY);
export const onGetCyclesHistoryError = makeActionCreator(GET_CYCLES_HISTORY_ERROR, 'payload');
export const onGetCyclesHistorySuccess = makeActionCreator(GET_CYCLES_HISTORY_SUCCESS, 'payload');

export const onGetHistoryCyclesThunk = (date, turno) => async dispatch => {
    dispatch(onGetCyclesHistory());
    try {
        const endpointParams =
            date && turno
                ? { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear(), turno }
                : null;

        if (!endpointParams) throw new Error('Faltan parámetros de históricos');

        const { data } = await getCycles(endpointParams);
        const ciclos = normalizeCycles(data);
        return batch(() => dispatch(onGetCyclesHistorySuccess({ data: ciclos })));
    } catch (error) {
        return batch(() => dispatch(onGetCyclesHistoryError({ error })));
    }
};